<template>
  <p-form-element :class="classList" show-messages :errors="innerErrors" :messages="innerMessages">
    <input
      :id="'radio-field-' + _uid"
      v-model="computedValue"
      type="radio"
      :name="name"
      :disabled="disabled"
      :checked="checked"
      :value="trueValue"
      @keyup="onKeyUp"
      @blur="onBlur"
      @change="onChange"
    >
    <div class="p-radio-field-label-wrapper">
      <label :for="'radio-field-' + _uid">{{ label }}</label>
    </div>
  </p-form-element>
</template>

<script lang="ts">
  import validatable from '../../mixins/validatable/validatable';
  import mixins from '../../mixins';

  export default mixins(validatable).extend({
    props: {
      label: { default: undefined, type: String },
      value: { default: undefined, type: undefined },
      name: { default: undefined, type: String },
      checked: { default: false, type: Boolean },
      disabled: { default: false, type: Boolean },
      trueValue: { default: undefined, type: undefined },
    },
    data: () => ({
      navigatedUsingKeyboard: false,
    }),
    computed: {
      computedValue: {
        set(value: any) {
          this.$emit('input', value);
        },
        get() {
          return this.value;
        },
      },
      classList(): Record<string, boolean> {
        return {
          'p-radio-field': true,
          'keyboard-focus': this.navigatedUsingKeyboard,
          invalid: (this.innerErrors ?? []).length > 0,
        };
      },
    },
    methods: {
      onChange(event: InputEvent) {
        const { checked } = event.target as any;
        this.$emit('change', checked);
      },
      onKeyUp() {
        this.navigatedUsingKeyboard = true;
      },
      onBlur() {
        this.navigatedUsingKeyboard = false;
        this.$emit('blur');
      },
    },
  });
</script>
